import axiosClient from "./api";

export const getResourceSignedUrl = async (resourceId) => {
  const response = await axiosClient.get(`/resources/${resourceId}/signed-url`);
  return response.data?.data.signedUrl; 
};